import type { Resource } from '../../';
export const cart_couponCodes_rejection_generic: Resource = {"default":"An error has occurred when applying the coupon."};
